module.exports = __webpack_public_path__ + "img/salesforce-blue.c325822b.png";